module.exports = __webpack_public_path__ + "img/building_no_word.5c3a9be5.jpg";